import operationTypes from 'constants/operationTypes';

export const operationsWithoutNotarialRegistrationSection = [
  operationTypes.CONTRIBUTION,
  operationTypes.DIVIDENDS_DISTRIBUTION,
];
